import { useEffect } from "react";
import NotFoundIcon from "../assets/icons/NotFoundIcon";
import Footer from "../components/layouts/common/Footer";
import { useAppDispatch } from "../hooks";
import { shopSliceActions } from "../store/slices/shopSlice";

export default function NotFoundPage() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        document.title = "404 Not found";
        const refetchShopInfo = async () => {
            await dispatch(shopSliceActions.getDataShop());
        }
        window.addEventListener('load', () => refetchShopInfo());
    }, [])
    return (
        <div className="flex flex-col justify-between items-center min-h-screen min-w-screen">
            <div className="flex-1 flex items-center">
                <div className="flex flex-col gap-4 items-center">
                    <NotFoundIcon />
                    <p className="text-[#0088FF] text-3xl font-normal max-md:text-center max-md:text-base">Xin lỗi, trang bán hàng này hiện tại chưa có</p>
                </div>
            </div>
            <Footer />
        </div>
    )
}